import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getCountries, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SlidersArray from "./SliderArray";

const Section = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { countries } = useSelector((state) => state.countries);
  const { loading, error, section } = useSelector((state) => state.section);
  const [sliders, setSliders] = useState([]);

  const { reset, handleSubmit } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "home",
        slug: "intro",
      }),
    );
    dispatch(getCountries());
  }, [dispatch]);

  useEffect(() => {
    reset(section);
    setSliders(section?.items);
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    data.items = sliders;
    if (sliders.some((item) => !item.image)) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    dispatch(
      editSection({ slug: "intro", page: "home", data: { section: data } }),
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"intro"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={12} md={12}>
                <SlidersArray
                  countries={countries}
                  sliders={sliders}
                  setSliders={setSliders}
                />
                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Section;
